import { IoRefreshOutline } from "react-icons/io5";
import { relativeTime } from "./useEdiExtractStatus";

const RefreshButton = ({ onRetry, isFetching }) => (
    <button
        type="button"
        className="edi-extract-selfservice-card__refresh-btn"
        onClick={onRetry}
        disabled={isFetching}
        title="Refresh status"
    >
        <IoRefreshOutline size={15} className={isFetching ? "spin" : ""} />
        {isFetching ? "Refreshing…" : "Refresh"}
    </button>
);

const EdiExtractStatusCard = ({
    isError,
    isFetching,
    state,
    failed,
    disabled,
    data,
    failedJobs,
    canRetry,
    onRetry,
    onTriggerClick,
    onRetryFailedClick,
}) => {
    if (isError) {
        return (
            <div className="edi-extract-selfservice-card">
                <p className="edi-extract-selfservice-card__label">Current status</p>
                <div className="edi-extract-selfservice-card__header">
                    <span className="edi-extract-selfservice-card__pill UNKNOWN">
                        <span className="edi-extract-selfservice-card__pill-dot" />
                        Unknown
                    </span>
                    <span className="edi-extract-selfservice-card__detail">
                        Couldn't reach the status check. The extract itself may still be fine — try refreshing.
                    </span>
                </div>
                <RefreshButton onRetry={onRetry} isFetching={isFetching} />
            </div>
        );
    }

    let pillClass = "IDLE";
    let pillLabel = "Idle";
    let detail = "No extract has been run on demand yet.";

    if (state === "running") {
        pillClass = "RUNNING";
        pillLabel = "Running";
        detail = `Started ${relativeTime(data?.startDate) || "moments ago"} — usually takes a few minutes. Refresh to check for updates.`;
    } else if (failed) {
        pillClass = "ERROR";
        pillLabel = "Completed with errors";
        detail = failedJobs?.length > 0
            ? `Last run ${relativeTime(data?.stopDate)} failed: ${failedJobs.join(", ")}. Other jobs completed normally.`
            : `Last run ${relativeTime(data?.stopDate)} finished with errors — check the execution in Step Functions before running again.`;
    } else if (state === "succeeded") {
        pillClass = "SUCCESS";
        pillLabel = "Success";
        detail = `Last run completed ${relativeTime(data?.stopDate)}.`;
    }

    return (
        <div className="edi-extract-selfservice-card">
            <p className="edi-extract-selfservice-card__label">Current status</p>
            <div className="edi-extract-selfservice-card__header">
                <span className={`edi-extract-selfservice-card__pill ${pillClass}`}>
                    <span className="edi-extract-selfservice-card__pill-dot" />
                    {pillLabel}
                </span>
                <span className="edi-extract-selfservice-card__detail">{detail}</span>
                <RefreshButton onRetry={onRetry} isFetching={isFetching} />
            </div>

            <div className="edi-extract-selfservice-card__action">
                {canRetry && (
                    <button
                        className="finance-ops__link-btn"
                        disabled={disabled}
                        onClick={onRetryFailedClick}
                    >
                        Retry failed: {failedJobs.join(", ")}
                    </button>
                )}
                <button
                    className="finance-ops__primary-btn"
                    disabled={disabled}
                    onClick={onTriggerClick}
                >
                    {state === "running" ? "Running…" : "Run extract"}
                </button>
            </div>
        </div>
    );
};

export default EdiExtractStatusCard;
